document.documentElement.classList.remove('no-js');

const qs = (selector, root = document) => root.querySelector(selector);
const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];
const money = (cents, currency = 'PKR') => {
  try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, maximumFractionDigits: 0 }).format((cents || 0) / 100); }
  catch (_) { return `${((cents || 0) / 100).toFixed(0)} ${currency}`; }
};

function lockPage(value){ document.body.classList.toggle('drawer-open', value); }
function show(el){ if(el){ el.hidden=false; lockPage(true); } }
function hide(el){ if(el){ el.hidden=true; lockPage(false); } }

function showToast(message){
  const toast=qs('[data-toast]'); if(!toast)return;
  toast.textContent=message; toast.hidden=false;
  clearTimeout(window.__mkToastTimer);
  window.__mkToastTimer=setTimeout(()=>{toast.hidden=true;},2400);
}

async function getCart(){
  const response=await fetch('/cart.js',{headers:{Accept:'application/json'}});
  if(!response.ok) throw new Error('Cart unavailable');
  return response.json();
}

function syncCartCount(cart){
  qsa('[data-cart-count]').forEach(n=>n.textContent=cart.item_count);
  qsa('[data-cart-drawer-count]').forEach(n=>n.textContent=`${cart.item_count} ${cart.item_count===1?'item':'items'}`);
}

function renderMiniCart(cart){
  const body=qs('[data-cart-drawer-body]'); const foot=qs('[data-cart-drawer-foot]');
  if(!body)return;
  syncCartCount(cart);
  if(!cart.item_count){
    body.innerHTML='<div class="mini-cart__empty"><div style="font-family:Georgia,serif;font-size:55px;color:var(--mk-pink)">♡</div><h3 style="font-family:Georgia,serif;font-weight:500;font-size:30px;margin:5px 0">Your bag is feeling light.</h3><p>Add something lovely for a little wardrobe.</p></div>';
    if(foot)foot.hidden=true; return;
  }
  body.innerHTML=cart.items.map(item=>{
    const img=item.image?`<img src="${item.image}" alt="">`:'<div class="placeholder-premium" style="width:92px;height:112px;border-radius:16px"><span>♡</span></div>';
    const variant=item.variant_title && item.variant_title!=='Default Title'?`<span>${item.variant_title} · Qty ${item.quantity}</span>`:`<span>Qty ${item.quantity}</span>`;
    return `<div class="mini-cart__item"><a href="${item.url}">${img}</a><div class="mini-cart__item-copy"><p>MINHA KIDZ</p><a href="${item.url}"><h4>${item.product_title}</h4></a>${variant}</div><div class="mini-cart__item-price">${money(item.final_line_price,cart.currency||'PKR')}</div></div>`;
  }).join('');
  if(foot){foot.hidden=false; const sub=qs('[data-cart-subtotal]',foot); if(sub)sub.textContent=money(cart.total_price,cart.currency||'PKR');}
}

async function openCart(){
  const drawer=qs('[data-cart-drawer]'); show(drawer);
  try{renderMiniCart(await getCart());}catch(_){const b=qs('[data-cart-drawer-body]'); if(b)b.innerHTML='<div class="mini-cart__empty">Open your cart to see your items.</div>';}
}

function closeCart(){ hide(qs('[data-cart-drawer]')); }
function openMenu(){ const el=qs('[data-mobile-drawer]'); show(el); qs('[data-menu-toggle]')?.setAttribute('aria-expanded','true'); }
function closeMenu(){ hide(qs('[data-mobile-drawer]')); qs('[data-menu-toggle]')?.setAttribute('aria-expanded','false'); }
function openSearch(){ const el=qs('[data-search-overlay]'); show(el); setTimeout(()=>qs('[data-search-input]',el)?.focus(),80); }
function closeSearch(){ hide(qs('[data-search-overlay]')); }

function bindQuickAdd(form){
  if(form.dataset.bound)return; form.dataset.bound='1';
  form.addEventListener('submit',async e=>{
    e.preventDefault(); const btn=qs('button[type="submit"]',form); const old=btn?.innerHTML;
    if(btn){btn.disabled=true;btn.innerHTML='<span>Adding…</span><b>＋</b>';}
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if(!r.ok)throw new Error(); const cart=await getCart(); syncCartCount(cart); renderMiniCart(cart); showToast('Added to your bag ♡'); show(qs('[data-cart-drawer]'));
    }catch(_){form.submit();return;}finally{if(btn){btn.disabled=false;btn.innerHTML=old||'<span>Quick add</span><b>＋</b>';}}
  });
}

function bindProductForm(form){
  if(form.dataset.bound)return; form.dataset.bound='1';
  form.addEventListener('submit',async e=>{
    if(!window.fetch)return; e.preventDefault(); const btn=qs('[data-add-to-cart]',form); const old=btn?.textContent;
    if(btn){btn.disabled=true;btn.textContent='Adding…';}
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if(!r.ok)throw new Error(); const cart=await getCart(); syncCartCount(cart); renderMiniCart(cart); showToast('Added to your bag ♡'); show(qs('[data-cart-drawer]'));
    }catch(_){form.submit();return;}finally{if(btn){btn.disabled=false;btn.textContent=old||'Add to bag ↗';}}
  });
}

function initHeader(){
  qsa('[data-menu-toggle]').forEach(b=>{if(!b.dataset.bound){b.dataset.bound='1';b.addEventListener('click',openMenu);}});
  qsa('[data-drawer-close]').forEach(b=>{if(!b.dataset.bound){b.dataset.bound='1';b.addEventListener('click',closeMenu);}});
  qsa('[data-search-open]').forEach(b=>{if(!b.dataset.bound){b.dataset.bound='1';b.addEventListener('click',openSearch);}});
  qsa('[data-search-close]').forEach(b=>{if(!b.dataset.bound){b.dataset.bound='1';b.addEventListener('click',closeSearch);}});
  qsa('[data-cart-open]').forEach(b=>{if(!b.dataset.bound){b.dataset.bound='1';b.addEventListener('click',openCart);}});
  qsa('[data-cart-close]').forEach(b=>{if(!b.dataset.bound){b.dataset.bound='1';b.addEventListener('click',closeCart);}});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeMenu();closeSearch();closeCart();}});

  const header=qs('[data-site-header]'); if(!header||header.dataset.scrollBound)return; header.dataset.scrollBound='1';
  let last=window.scrollY; let ticking=false;
  const update=()=>{
    const y=window.scrollY; header.classList.toggle('is-scrolled',y>18);
    header.classList.toggle('is-hidden',y>140 && y>last+4 && !document.body.classList.contains('drawer-open'));
    if(y<last-6)header.classList.remove('is-hidden'); last=y;
    const max=document.documentElement.scrollHeight-window.innerHeight; const progress=qs('[data-page-progress]'); if(progress)progress.style.width=`${max>0?(y/max)*100:0}%`; ticking=false;
  };
  window.addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(update);ticking=true;}},{passive:true}); update();
}

function initSplitText(root=document){
  qsa('[data-split]',root).forEach(el=>{
    if(el.dataset.splitDone)return; el.dataset.splitDone='1';
    const words=el.textContent.trim().split(/\s+/); el.setAttribute('aria-label',el.textContent.trim());
    el.innerHTML=words.map((w,i)=>`<span class="split-word" aria-hidden="true" style="--word-index:${i}">${w}${i<words.length-1?'&nbsp;':''}</span>`).join('');
    const reveal=()=>el.classList.add('is-split-visible');
    if(!('IntersectionObserver'in window)){reveal();return;}
    new IntersectionObserver((entries,obs)=>entries.forEach(entry=>{if(entry.isIntersecting){reveal();obs.unobserve(entry.target);}}),{threshold:.25}).observe(el);
  });
}

function initReveals(root=document){
  const items=qsa('.reveal',root); if(!items.length)return;
  items.forEach((el,i)=>{el.style.setProperty('--reveal-delay',`${Math.min((i%4)*70,210)}ms`);});
  if(!('IntersectionObserver'in window)){items.forEach(x=>x.classList.add('is-visible'));return;}
  const obs=new IntersectionObserver((entries)=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');obs.unobserve(e.target);}}),{threshold:.12,rootMargin:'0px 0px -35px'});
  items.forEach(el=>obs.observe(el));
}

function initParallax(){
  if(matchMedia('(pointer: coarse)').matches||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  qsa('[data-parallax-scene]').forEach(scene=>{
    if(scene.dataset.parallaxBound)return; scene.dataset.parallaxBound='1';
    scene.addEventListener('pointermove',e=>{
      const r=scene.getBoundingClientRect(); const x=(e.clientX-r.left)/r.width-.5; const y=(e.clientY-r.top)/r.height-.5;
      qsa('[data-depth]',scene).forEach(el=>{const d=parseFloat(el.dataset.depth||'.02');el.style.transform=`translate3d(${x*1000*d}px,${y*800*d}px,0)`;});
    });
    scene.addEventListener('pointerleave',()=>qsa('[data-depth]',scene).forEach(el=>el.style.transform=''));
  });
}

function initTilt(root=document){
  if(matchMedia('(pointer: coarse)').matches||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  qsa('[data-tilt]',root).forEach(el=>{
    if(el.dataset.tiltBound)return; el.dataset.tiltBound='1';
    el.addEventListener('pointermove',e=>{const r=el.getBoundingClientRect();const x=(e.clientX-r.left)/r.width-.5;const y=(e.clientY-r.top)/r.height-.5;el.style.transform=`perspective(900px) rotateX(${-y*3.5}deg) rotateY(${x*3.5}deg) translateY(-3px)`;});
    el.addEventListener('pointerleave',()=>el.style.transform='');
  });
}

function initMagnetic(root=document){
  if(matchMedia('(pointer: coarse)').matches||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  qsa('.magnetic',root).forEach(el=>{
    if(el.dataset.magBound)return; el.dataset.magBound='1';
    el.addEventListener('pointermove',e=>{const r=el.getBoundingClientRect();el.style.transform=`translate(${(e.clientX-r.left-r.width/2)*.08}px,${(e.clientY-r.top-r.height/2)*.12}px)`;});
    el.addEventListener('pointerleave',()=>el.style.transform='');
  });
}

function initProductControls(root=document){
  qsa('[data-variant-select]',root).forEach(select=>{
    if(select.dataset.bound)return; select.dataset.bound='1';
    select.addEventListener('change',e=>{
      const option=e.target.options[e.target.selectedIndex]; const form=e.target.closest('form'); const panel=e.target.closest('.product-buy-panel')||document;
      const price=qs('[data-product-price]',panel), compare=qs('[data-product-compare]',panel), add=qs('[data-add-to-cart]',form);
      if(price&&option.dataset.price)price.textContent=option.dataset.price;
      if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
      if(add){const ok=option.dataset.available==='true';add.disabled=!ok;add.textContent=ok?'Add to bag ↗':'Sold out';}
      if(history.replaceState&&option.value){const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);}
    });
  });
  qsa('[data-accordion-button]',root).forEach(btn=>{
    if(btn.dataset.bound)return; btn.dataset.bound='1';
    btn.addEventListener('click',()=>{const item=btn.closest('[data-accordion-item]');const panel=qs('[data-accordion-panel]',item);const open=btn.getAttribute('aria-expanded')==='true';btn.setAttribute('aria-expanded',String(!open));const icon=qs('b,span:last-child',btn);if(icon)icon.textContent=open?'＋':'−';if(panel)panel.hidden=open;});
  });
  qsa('[data-quantity-stepper]',root).forEach(stepper=>{
    if(stepper.dataset.bound)return; stepper.dataset.bound='1'; const input=qs('input[type="number"]',stepper);
    qs('[data-qty-minus]',stepper)?.addEventListener('click',()=>{input.value=Math.max(parseInt(input.min||'1',10),parseInt(input.value||'1',10)-1);});
    qs('[data-qty-plus]',stepper)?.addEventListener('click',()=>{input.value=parseInt(input.value||'1',10)+1;});
  });
  qsa('[data-quick-add]',root).forEach(bindQuickAdd); qsa('[data-product-form]',root).forEach(bindProductForm);
}


function initLuxeReveals(root=document){
  const items=qsa('[data-luxe-reveal]',root);
  if(!items.length)return;
  items.forEach((el,i)=>el.style.setProperty('--luxe-delay',`${Math.min((i%5)*85,340)}ms`));
  if(!('IntersectionObserver'in window)){items.forEach(el=>el.classList.add('is-luxe-visible'));return;}
  const obs=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(entry.isIntersecting){entry.target.classList.add('is-luxe-visible');obs.unobserve(entry.target);}
  }),{threshold:.13,rootMargin:'0px 0px -35px'});
  items.forEach(el=>obs.observe(el));
}

function initSpotlights(root=document){
  if(matchMedia('(pointer: coarse)').matches||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  qsa('[data-spotlight]',root).forEach(el=>{
    if(el.dataset.spotBound)return; el.dataset.spotBound='1'; el.classList.add('spotlight-ready');
    el.addEventListener('pointermove',e=>{
      const r=el.getBoundingClientRect();
      el.style.setProperty('--spot-x',`${e.clientX-r.left}px`);
      el.style.setProperty('--spot-y',`${e.clientY-r.top}px`);
    });
  });
}

function initScrollShift(root=document){
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const items=qsa('[data-scroll-shift]',root); if(!items.length)return;
  let ticking=false;
  const update=()=>{
    const vh=window.innerHeight;
    items.forEach(el=>{
      const r=el.getBoundingClientRect();
      if(r.bottom<0||r.top>vh)return;
      const amount=parseFloat(el.dataset.scrollShift||'14');
      const progress=((r.top+r.height*.5)-vh*.5)/vh;
      el.style.translate=`0 ${progress*amount}px`;
    });
    ticking=false;
  };
  window.addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(update);ticking=true;}},{passive:true}); update();
}

function initLuxuryIntro(){
  const loader=qs('[data-luxe-loader]'); if(!loader)return;
  const hideLoader=()=>{loader.classList.add('is-done');setTimeout(()=>loader.remove(),850);};
  if(window.Shopify&&Shopify.designMode){loader.remove();return;}
  if(document.readyState==='complete')setTimeout(hideLoader,320);else window.addEventListener('load',()=>setTimeout(hideLoader,320),{once:true});
}

function initHeroVelocity(){
  if(matchMedia('(pointer: coarse)').matches||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const hero=qs('.couture-hero'); if(!hero||hero.dataset.velocityBound)return; hero.dataset.velocityBound='1';
  const title=qs('.couture-hero__backtype',hero); if(!title)return;
  let last=window.scrollY, raf=0;
  const update=()=>{const now=window.scrollY; const d=Math.max(-20,Math.min(20,now-last)); title.style.transform=`skewY(${d*.045}deg) translateY(${Math.min(now*.05,35)}px)`; last=now; raf=0;};
  window.addEventListener('scroll',()=>{if(!raf)raf=requestAnimationFrame(update);},{passive:true});
}

function initTheme(root=document){ initHeader(); initSplitText(root); initReveals(root); initLuxeReveals(root); initParallax(); initTilt(root); initMagnetic(root); initSpotlights(root); initScrollShift(root); initProductControls(root); initHeroVelocity(); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{initLuxuryIntro();initTheme();});else{initLuxuryIntro();initTheme();}
document.addEventListener('shopify:section:load',e=>initTheme(e.target));

class ProductRecommendations extends HTMLElement{
  connectedCallback(){const url=this.dataset.url;if(!url||this.innerHTML.trim())return;fetch(url).then(r=>r.text()).then(text=>{const html=document.createElement('div');html.innerHTML=text;const source=html.querySelector('product-recommendations');if(source&&source.innerHTML.trim()){this.innerHTML=source.innerHTML;initTheme(this);}}).catch(()=>{});}
}
if(!customElements.get('product-recommendations'))customElements.define('product-recommendations',ProductRecommendations);
